import { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { getMe } from '@/api';
import { setToken } from '@/auth/token';
import { postLoginPath } from '@/platform';

export default function AuthCallback() {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const [err, setErr] = useState<string | null>(null);

  useEffect(() => {
    const token = params.get('token');
    const fallback = postLoginPath();
    const next = params.get('next') || fallback;
    if (!token) {
      setErr('missing token');
      return;
    }
    setToken(token);
    getMe()
      .then((user) => {
        setToken(token, user);
        navigate(next.startsWith('/') ? next : fallback, { replace: true });
      })
      .catch(() => {
        setErr('could not complete sign-in');
      });
  }, [navigate, params]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-bg text-textp">
      <div className="text-sm text-texts">{err || 'Signing you in…'}</div>
    </div>
  );
}
